import React, { ReactElement } from 'react'

import useResizeObserver from 'use-resize-observer'
import { mergeRefs } from 'website/src/lib/hooks'

type Props = {
    children: (dimens: { width: number; height: number }) => ReactElement
    className?: string
}

const style = {
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
}

export const FillFlexParent = React.forwardRef(function FillFlexParent(
    { children, ...props }: Props,
    forwardRef,
) {
    const { ref, width, height } = useResizeObserver({})
    return (
        <div {...props} style={style} ref={mergeRefs(ref, forwardRef)}>
            {width && height ? children({ width, height }) : null}
        </div>
    )
})
